import Image from 'next/legacy/image'
import cx from 'classnames'
import { Container } from 'components/atomic'
import { useViewport } from 'contexts/viewport'
import styles from './image-masthead.module.scss'

type PropTypes = {
  image?: string
  children: React.ReactNode
  className?: string
}

const Masthead = ({ image, children, className = '' }: PropTypes) => {
  const { isMobile } = useViewport()
  const imageSrc = image || (isMobile ? '/images/home/masthead-mobile.png' : '/images/home/masthead.png')

  return (
    <div className="relative">
      <div className={cx(styles.image, className)}>
        <Image src={imageSrc} layout="fill" objectFit="cover" alt="Masthead background" priority />
      </div>
      <Container className="relative">{children}</Container>
    </div>
  )
}

export default Masthead
